import axios, { AxiosError } from "axios";
import { memo, useEffect } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { API_URL } from "../consts";
import { Messaggio } from "../prismaTypes";
import { Loading } from "../ui/Loading";
import { Typography } from "@mui/material";
import { uiStore } from "../uiStore";

export const ComunicazionePage = memo(function ComunicazionePage() {
  const { id } = useParams();
  const setTitle = uiStore((state) => state.setTitle);
  useEffect(() => setTitle("Comunicazioni"), [setTitle]);

  const { isLoading, data } = useQuery<unknown, AxiosError, { messaggi: Messaggio[] }>(
    ["messaggi/onSide"],
    () => axios.get(API_URL + "messaggi/onSide").then((res) => res.data)
  );

  if (isLoading) return <Loading />;

  const mess = data?.messaggi.find((m) => m.id.toString() === id);

  if (!mess) return <Loading />;

  return (
    <>
      <Typography component="h1" variant="h5" sx={{ mb: 2 }}>
        {mess.titolo}
      </Typography>

      <Typography variant="body1" className="preWrap">
        {mess.testo}
      </Typography>
    </>
  );
});
